import { Component, effect, inject, isDevMode, OnInit, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { ToasterComponent } from 'components/toaster/toaster.component';
import { environment } from 'environments/environment';
import moment from 'moment';
import { filter } from 'rxjs';
import { LayoutStore } from 'stores/layout.store';

@Component({
	selector: 'app-root',
	imports: [RouterOutlet, ToasterComponent],
	templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
	public readonly layoutStore = inject(LayoutStore);
	private readonly destroyRef = inject(DestroyRef);
	private readonly router = inject(Router);
	private readonly titleService = inject(Title);
	private readonly gtmService = inject(GoogleTagManagerService);

	constructor() {
		this.setTitlePage();
	}

	public ngOnInit() {
		moment.locale('pt-br');
		this.routerEvent();
	}

	private async routerEvent() {
		const stageAmbiente = environment.stage + (isDevMode() ? '-localhost' : '');

		this.router.events
			.pipe(takeUntilDestroyed(this.destroyRef))
			.pipe(filter((event) => event instanceof NavigationEnd))
			.subscribe((event: NavigationEnd) => {
				if (environment.gtmId) {
					const gtmTag = {
						event: 'page',
						pageName: event.urlAfterRedirects,
						environment: stageAmbiente,
					};
					this.gtmService.pushTag(gtmTag);
				}
			});
	}

	private async setTitlePage() {
		effect(() => {
			const currentTitle = this.layoutStore.topnav().title;
			const titlePrefix = environment.titlePrefix;

			const titlePage = currentTitle ? `${currentTitle} - ${titlePrefix}` : titlePrefix;

			this.titleService.setTitle(titlePage);
		});
	}
}
